interface BannerProps {
  text?: string;
  link?: string;
  linkLabel?: string;
  backgroundColor?: string;
  textColor?: string;
}

export function BannerBlock({ props }: { props: BannerProps }) {
  if (!props.text) return null;
  return (
    <div
      className="w-full px-6 py-4 rounded-xl flex items-center justify-between gap-4 flex-wrap"
      style={{
        backgroundColor: props.backgroundColor ?? 'var(--color-primary)',
        color: props.textColor ?? '#ffffff',
      }}
    >
      <p className="font-medium text-sm">{props.text}</p>
      {props.link && props.linkLabel && (
        <a
          href={props.link}
          className="text-sm font-semibold underline hover:no-underline flex-shrink-0"
          style={{ color: props.textColor ?? '#ffffff' }}
        >
          {props.linkLabel}
        </a>
      )}
    </div>
  );
}
